import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import throttle from 'lodash/throttle';

import { Table, Column, Pager, Input, Select } from '@smartplatform/ui';
import store from '../../store';
import './style.scss';

const PER_PAGE = 20;

@observer
export default class DebugLog extends React.Component {

	@observable logs = [];
	@observable page = 1;
	@observable level = 'все';
	@observable search = '';
	
	constructor(props) {
		super(props);
		this.init = throttle(this.init, 250, { leading: true, trailing: true });
		this.init();
	}
	
	init = async () => {
		const where = { and: []};

		const trimmed = this.search.trim();
		if (trimmed.length > 0) {
			where.and.push({ description: { ilike: `%${trimmed}%` }});
		}

		if (this.level !== 'все') {
			where.and.push({ level: this.level });
		}
		
		this.logs = await store.model.DebugLog.find({
			where,
			limit: PER_PAGE,
			skip: (this.page - 1) * PER_PAGE,
			order: 'id desc',
			include: ['owner']
		});
	};

	onPageChange = page => {
		this.page = page;
		this.init();
	};
	
	onSearch = e => {
		this.search = e.target.value;
		this.init();
	};
	
	onLevelChange = level => {
		this.level = level;
		this.init();
	};
	
	screenshot = record => record.screenshot ?
		<a target="_blank" href={record.downloadFile('screenshot')}>
			Скриншот
			{/*<img src={record.downloadFile('screenshot') + '?image=[{"resize":{"width":200,"height":140}}]'} alt="" />*/}
		</a>
		:
		'';
	
	owner = record => record.owner ? (record.owner.username || record.owner.email) : '-';
	
	renderLevel = record => <span className={'level level-' + record.level}>{record.level}</span>;
	
	render() {
		return <div className="debug-logs">
			<div className="filters">
				<Input type="text" value={this.search} onChange={this.onSearch} style={{ width: 300 }} placeholder="Поиск по описанию" />
				<Select
					items={['все', 'error', 'warning', 'info']}
					value={this.level}
					onChange={this.onLevelChange}
					className="drop-down-md"
					isRequired
					noSearch
				/>
			</div>
			<Pager current={this.page} itemsPerPage={PER_PAGE} onChange={this.onPageChange} totalCount={this.logs.totalCount} />
			<Table records={this.logs} className="multiline" clickable={false}>
				<Column width={60} computed={this.renderLevel} label="Уровень" />
				<Column property="description" label="Описание" />
				<Column computed={this.screenshot} className="screenshot" label="Скриншот" />
				<Column computed={this.owner} label="Пользователь" />
				<Column property="createdAt" label="Дата" />
			</Table>
		</div>;
	}
	
}
